export default __webpack_public_path__ + "static/media/31fb7599c2716d4a.4c797d4ac13eb7a1797a7815939f190b.svg";